import { TextField, TextFieldProps, SxProps, Theme } from '@mui/material';
import {
  useController,
  UseControllerProps,
  Control,
  FieldValues,
  Path,
  PathValue,
} from 'react-hook-form';

interface Props<T extends FieldValues> extends UseControllerProps<T> {
  name: Path<T>;
  label: string;
  control: Control<T>;
  fullWidth?: boolean;
  multiline?: boolean;
  rows?: number;
  type?: string;
  sx?: SxProps<Theme>;
  InputProps?: TextFieldProps['InputProps'];
}

export default function AppTextInput<T extends FieldValues>(props: Props<T>) {
  const { fieldState, field } = useController({
    ...props,
    defaultValue: '' as PathValue<T, Path<T>>,
  });

  return (
    <TextField
      {...props}
      {...field}
      multiline={props.multiline}
      rows={props.rows}
      type={props.type}
      fullWidth
      variant="outlined"
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
    />
  );
}
